// SplashScreen.js
import React from 'react';
import { LoaderSplash, splashPattern, RiaPay, cowboySplashScreen, cowboySplashLogo, ropayLogo } from '../assets/images/images';
import '../container/frontend/scss/splash.scss';

const SplashScreen = () => {
  // console.log(splashPattern); // Ensure splashPattern is a valid URL or path

  return (
    <div className='center-item'>
      <div className='splash-bg'>
        <div className='splash-anim' style={{ 
          backgroundImage: `url(${cowboySplashScreen})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}>
          <div className='logo'>
            <img style={{height:'60px',width:'258px'}}src={cowboySplashLogo} />
          </div> 

          <div className='bottom-div'>
            <div className='ropay-logo-main-div'>
              <img src={ropayLogo} style={{width:'69px',height:'13px;'}} />
            </div>
              <p className='ropay-main-text'>Powered By
                <span className='ropay-sub-text'> RoPay.pk
                  </span>
              </p>
          </div>
         
        </div>
      </div>
    </div>
  );
};



export default SplashScreen;
